// custom typeface
import "./src/components/fonts.css";

// Bootstrap applique `scroll-behavior: smooth` sur :root : le retour en haut
// fait par Gatsby s'animait donc depuis la position précédente (souvent le footer)
// et pouvait s'arrêter au milieu de la page. Lors d'une navigation entre pages,
// on remonte instantanément ; les ancres (#hash) gardent le défilement animé.
let isPopNavigation = false;
if (typeof window !== "undefined") {
  window.addEventListener("popstate", () => {
    isPopNavigation = true;
  });
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const wasPop = isPopNavigation;
  isPopNavigation = false;

  if (location.hash) return true;

  const [, savedY] = getSavedScrollPosition(location);
  const top = wasPop && savedY ? savedY : 0;

  const html = document.documentElement;
  const previousBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = "auto";
  window.scrollTo(0, top);
  html.style.scrollBehavior = previousBehavior;
  return false;
};
